import { styled } from "@mui/system";
import { Field } from "formik";

export default styled(Field)`
  font: inherit;
  padding: 0.5rem;
  box-sizing: border-box;
`;
